export const services = [
    {
        title: "Planning",
        goal: "Develop a clear, actionable roadmap for IT and business transformation.",
        actions: [
            "Assess current systems, processes, and pain points.",
            "Define project scope, objectives, and success metrics.",
            "Align technology initiatives with long-term business goals.",
        ],
        outcome: [
            "Clarity on priorities and execution sequence.",
            "Reduced project risks through early-stage validation.",
        ],
    },
    {
        title: "Detailed Infrastructure Solution",
        goal: "Design a robust and scalable IT infrastructure tailored to business needs.",
        actions: [
            "Create detailed architecture diagrams for network, servers, and cloud services.",
            "Specify hardware, software, and integration requirements.",
            "Incorporate security, compliance, and disaster recovery protocols.",
        ],
        outcome: [
            "Future-ready infrastructure that supports growth.",
            "Improved reliability and system performance.",
        ],
    },
    {
        title: "Implementation",
        goal: "Deploy the planned solutions with minimal disruption to operations.",
        actions: [
            "Configure systems, applications, and integrations as per design.",
            "Migrate data securely with minimal downtime.",
            "Conduct pilot testing and user acceptance validation.",
        ],
        outcome: [
            "Seamless transition from old to new systems.",
            "Faster adoption with minimal operational impact.",
        ],
    },
    {
        title: "Deployment & Product Installation",
        goal: "Roll out solutions across the organization and ensure smooth adoption.",
        actions: [
            "Install and configure hardware, software, and cloud tools.",
            "Provide training and documentation for end-users.",
            "Set up monitoring and support mechanisms for post-launch stability.",
        ],
        outcome: [
            "Successful go-live within planned timelines.",
            "High user adoption and reduced support issues.",
        ],
    },
];
